/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

/**
 * The type of order to be created. A `FULL_WITHDRAWAL` may automatically adjust the order amount to account for any interest accrued and realised between order placement and completion
 */
export type OrderType = typeof OrderType[keyof typeof OrderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderType = {
  DEPOSIT: 'DEPOSIT',
  PARTIAL_WITHDRAWAL: 'PARTIAL_WITHDRAWAL',
  FULL_WITHDRAWAL: 'FULL_WITHDRAWAL',
} as const;
